import { PrinterIcon } from "assets/icon/PrinterIcon";

export default function PrintButton(props){
    return(
        <button className="bg-black rounded-lg px-2 py-1 sm:px-3 sm:py-2 flex items-center gap-4 text-white" onClick={props?.onClick}>
            <PrinterIcon className="w-4 sm:w-5 fill-white" />
            <span>Print</span>
        </button>
    )
}